import "./holiday-cabin-class.scss";

import { useEffect, useState } from "react";

import { ReactComponent as ContentCopyIcon } from "../../assets/icons/klm/ic_content_copy.svg";
import HolidayCabinClassModal from "./holiday-cabin-class-modal/holiday-cabin-class-modal";
import HolidayCabinClassTabs from "./cabin-class-tabs/holiday-cabin-class-tabs";
import { cabinClassEnum } from "../../common/enums/cabinClassEnum";

const HolidayCabinClass = ({
  contentfulHolidayPage,
  filterInfo,
  handleOnClickTab,
  setCurrentCabinClass,
}) => {
  const [showCabinClassModal, setShowCabinClassModal] = useState(false);
  const [isDetailsPopupOpen, setIsDetailsPopupOpen] = useState(false);
  const [cabinClassContentfulData, setCabinClassContentfulData] = useState();
  const [cabinClassOptions, setCabinClassOptions] = useState();
  const [isPremiumEconomyEnabled, setIsPremiumEconomyEnabled] = useState(false);
  const [selectedCabinClassCode, setSelectedCabinClassCode] = useState([]);

  useEffect(() => {
    if (filterInfo?.cabinClassFilters) {
      let cabinClasses = {};
      const availableCabinClasses = filterInfo?.cabinClassFilters;
      for (const key in cabinClassEnum.apiKeys) {
        cabinClasses[key] = {
          displayName: cabinClassEnum.displayNames[key],
          enabled: availableCabinClasses
            .flatMap((x) => x.filterCode)
            .includes(key),
          selected:
            availableCabinClasses.find((x) => x.filterCode === key)?.selected ??
            false,
        };

        if (
          key === cabinClassEnum.apiKeys.PremiumEconomy &&
          cabinClasses[key]?.enabled
        ) {
          setIsPremiumEconomyEnabled(cabinClasses[key]?.enabled);
        }
      }
      setCabinClassOptions(cabinClasses);

      const cabinClassCode = getSelectedCabinClassCodes(
        filterInfo.cabinClassFilters
      );
      if (cabinClassCode.length > 0) {
        setSelectedCabinClassCode(cabinClassCode);
        setCurrentCabinClass(cabinClassCode);
      }
    }
  }, [filterInfo]);

  useEffect(() => {
    if (contentfulHolidayPage?.flight?.cabinClass) {
      setCabinClassContentfulData(contentfulHolidayPage?.flight.cabinClass);
    }
  }, [contentfulHolidayPage]);

  const openCabinClassModal = () => {
    setShowCabinClassModal(true);
    setIsDetailsPopupOpen(true);
  };

  const getSelectedCabinClassCodes = (cabinClassFilters) => {
    const selectedCabinClassFilter = cabinClassFilters.find(
      (item) => item.cabinClass?.selectedCabinClassCode?.length > 0
    );
    return selectedCabinClassFilter?.cabinClass.selectedCabinClassCode ?? [];
  };

  return (
    cabinClassOptions && (
      <div className="holiday-cabin-class-component">
        <div className="holiday-cabin-class-container">
          <div className="holiday-cabin-class-title">
            {contentfulHolidayPage?.cabinClassModal?.travelClasses}
          </div>
          <button
            className="holiday-cabin-class-modal-button"
            onClick={openCabinClassModal}
          >
            <ContentCopyIcon className="content-copy-icon" />
            <span className="compare-class-text">
              {contentfulHolidayPage?.cabinClassModal?.compareClassButton}
            </span>
          </button>
          {showCabinClassModal && (
            <HolidayCabinClassModal
              contentfulHolidayPage={contentfulHolidayPage}
              isOpen={isDetailsPopupOpen}
              handleClose={() => setIsDetailsPopupOpen(false)}
              cabinClassContentfulData={cabinClassContentfulData}
              isPremiumEconomyEnabled={isPremiumEconomyEnabled}
            />
          )}
        </div>
        <HolidayCabinClassTabs
          cabinClassOptions={cabinClassOptions}
          handleOnClickTab={handleOnClickTab}
          cabinClassContentfulData={cabinClassContentfulData}
          setCurrentCabinClass={setCurrentCabinClass}
          isPremiumEconomyEnabled={isPremiumEconomyEnabled}
          selectedCabinClassCode={selectedCabinClassCode}
        />
      </div>
    )
  );
};

export default HolidayCabinClass;
